import { render, staticRenderFns } from "./RegistroCompra.vue?vue&type=template&id=15aa2740&scoped=true"
import script from "./RegistroCompra.vue?vue&type=script&lang=js"
export * from "./RegistroCompra.vue?vue&type=script&lang=js"
import style0 from "./RegistroCompra.vue?vue&type=style&index=0&id=15aa2740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa2740",
  null
  
)

export default component.exports